var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.flag)?_c('div',{staticClass:"page"},[_c('pcheader'),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1),_c('ke-fu'),_c('pcfooter')],1):_c('div',[_c('phoneheader'),_c('div',{staticClass:"phoneContent"},[_c('router-view')],1),_c('phone-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }